__turbopack_context__.v({
  "container": "e5_5HW_container",
  "description": "e5_5HW_description",
  "icon": "e5_5HW_icon",
  "title": "e5_5HW_title",
});
